const urlConfig = {
    urlFile: 'https://apisiv.hargakurs.com/',
    urlProfile: 'https://apisiv.hargakurs.com/serve/imgprofile/',
    urlId: 'https://apisiv.hargakurs.com/serve/imgid/',
    urlFlag: 'https://apisiv.hargakurs.com/serve/imgflag/',
    urlInvoice: 'https://apisiv.hargakurs.com/bo/report/invoice?invoice='
}

export default urlConfig;
